import * as actionTypes from './actionTypes';
import axios from '../axios-instance';

export const getOrganizers = () => {
    return (dispatch) => {
        dispatch(getOrganizersStart());

        return axios({method: 'get', url: `/master-admin/platform-organizers`})
            .then((response) => {
                const data = response.data.organizers;
                dispatch(getOrganizersSuccess(data));
            })
            .catch((error) => {
                let errorMessage = "We couldn't approve the organizer. Please try again.";
                dispatch(getOrganizersFail(errorMessage));
            });
    };
};

const getOrganizersStart = () => {
    return {
        type: actionTypes.GET_ORGANIZERS_START,
    };
};
const getOrganizersSuccess = (data) => {
    return {
        type: actionTypes.GET_ORGANIZERS_SUCCESS,
        payload: data,
    };
};
const getOrganizersFail = (errorMessage) => {
    return {
        type: actionTypes.GET_ORGANIZERS_FAIL,
        payload: errorMessage,
    };
};

export const approveOrganizer = (userId, data) => {
    return (dispatch) => {
        dispatch(approveOrganizerStart());

        return axios({method: 'put', url: `/users/${userId}`, data: data})
            .then((response) => {
                dispatch(approveOrganizerSuccess());
            })
            .catch((error) => {
                let errorMessage = "We couldn't approve the organizer. Please try again.";
                dispatch(approveOrganizerFail(errorMessage));
            });
    };
};

const approveOrganizerStart = () => {
    return {
        type: actionTypes.APPROVE_ORGANIZER_START,
    };
};
const approveOrganizerSuccess = () => {
    return {
        type: actionTypes.APPROVE_ORGANIZER_SUCCESS,
    };
};
const approveOrganizerFail = (errorMessage) => {
    return {
        type: actionTypes.APPROVE_ORGANIZER_FAIL,
        payload: errorMessage,
    };
};

export const disableOrganizer = (userId, data) => {
    return (dispatch) => {
        dispatch(disableOrganizerStart());

        return axios({method: 'put', url: `/users/${userId}`, data: data})
            .then((response) => {
                dispatch(disableOrganizerSuccess());
            })
            .catch((error) => {
                let errorMessage = "We couldn't disable the organizer. Please try again.";
                dispatch(disableOrganizerFail(errorMessage));
            });
    };
};

const disableOrganizerStart = () => {
    return {
        type: actionTypes.DISABLE_ORGANIZER_START,
    };
};
const disableOrganizerSuccess = () => {
    return {
        type: actionTypes.DISABLE_ORGANIZER_SUCCESS,
    };
};
const disableOrganizerFail = (errorMessage) => {
    return {
        type: actionTypes.DISABLE_ORGANIZER_FAIL,
        payload: errorMessage,
    };
};

export const deleteOrganizer = (userId) => {
    return (dispatch) => {
        dispatch(deleteOrganizerStart());

        return axios({method: 'delete', url: `/users/${userId}`})
            .then((response) => {
                dispatch(deleteOrganizerSuccess());
            })
            .catch((error) => {
                let errorMessage = "We couldn't delete the organizer. Please try again.";
                dispatch(deleteOrganizerFail(errorMessage));
            });
    };
};

const deleteOrganizerStart = () => {
    return {
        type: actionTypes.DELETE_ORGANIZER_START,
    };
};
const deleteOrganizerSuccess = () => {
    return {
        type: actionTypes.DELETE_ORGANIZER_SUCCESS,
    };
};
const deleteOrganizerFail = (errorMessage) => {
    return {
        type: actionTypes.DELETE_ORGANIZER_FAIL,
        payload: errorMessage,
    };
};

export const getBrandingTranslation = (language) => {
    return (dispatch) => {
        dispatch(getBrandingTranslationStart());

        return axios({method: 'get', url: `/branding-translation/${language}`})
            .then((response) => {
                const data = response.data.translation;
                dispatch(getBrandingTranslationSuccess(data));
            })
            .catch((error) => {
                let errorMessage = '';
                dispatch(getBrandingTranslationFail(errorMessage));
            });
    };
};

const getBrandingTranslationStart = () => {
    return {
        type: actionTypes.GET_BRANDING_TRANSLATION_START,
    };
};
const getBrandingTranslationSuccess = (data) => {
    return {
        type: actionTypes.GET_BRANDING_TRANSLATION_SUCCESS,
        payload: data,
    };
};
const getBrandingTranslationFail = (errorMessage) => {
    return {
        type: actionTypes.GET_BRANDING_TRANSLATION_FAIL,
        payload: errorMessage,
    };
};

export const updateBrandingTranslation = (data) => {
    return (dispatch) => {
        dispatch(updateBrandingTranslationStart());
        return axios({method: 'post', url: `/branding-translation`, data: data})
            .then((response) => {
                dispatch(updateBrandingTranslationSuccess());
            })
            .catch((error) => {
                let errorMessage = '';
                dispatch(updateBrandingTranslationFail(errorMessage));
            });
    };
};
export const updateAdminBrandingTranslation = (data) => {
    return (dispatch) => {
        dispatch(updateBrandingTranslationStart());
        return axios({method: 'post', url: `/gdpr-template`, data: data})
            .then((response) => {
                dispatch(updateBrandingTranslationSuccess());
            })
            .catch((error) => {
                let errorMessage = '';
                dispatch(updateBrandingTranslationFail(errorMessage));
            });
    };
};

const updateBrandingTranslationStart = () => {
    return {
        type: actionTypes.UPDATE_BRANDING_TRANSLATION_START,
    };
};
const updateBrandingTranslationSuccess = () => {
    return {
        type: actionTypes.UPDATE_BRANDING_TRANSLATION_SUCCESS,
    };
};
const updateBrandingTranslationFail = (errorMessage) => {
    return {
        type: actionTypes.UPDATE_BRANDING_TRANSLATION_FAIL,
        payload: errorMessage,
    };
};

export const setAdminBrandingLanguage = (language) => {
    return {
        type: actionTypes.SET_ADMIN_BRANDING_LANGUAGE,
        payload: language,
    };
};

export const getAdminAllEvents = (page, perPage, sortBy, sortOrder, search) => {
    return (dispatch) => {
        dispatch(getAdminAllEventsStart());

        return axios({
            method: 'get',
            url: `/master-admin/platform-events${page ? `?page=${page}` : ''}${perPage ? `&perPage=${perPage}` : ''}${
                sortBy ? `&sortBy=${sortBy}` : ''
            }${sortOrder ? `&sortOrder=${sortOrder}` : ''}${search ? `&search=${search}` : ''}`,
        })
            .then((response) => {
                const data = response.data;
                dispatch(getAdminAllEventsSuccess(data));
            })
            .catch((error) => {
                let errorMessage = "We couldn't get all events. Please try again.";
                dispatch(getAdminAllEventsFail(errorMessage));
            });
    };
};

const getAdminAllEventsStart = () => {
    return {
        type: actionTypes.GET_ADMIN_ALL_EVENTS_START,
    };
};
const getAdminAllEventsSuccess = (data) => {
    return {
        type: actionTypes.GET_ADMIN_ALL_EVENTS_SUCCESS,
        payload: data,
    };
};
const getAdminAllEventsFail = (errorMessage) => {
    return {
        type: actionTypes.GET_ADMIN_ALL_EVENTS_FAIL,
        payload: errorMessage,
    };
};

export const setDataForDownloadExcel = (sortBy, sortOrder, search) => {
    return (dispatch) => {
        dispatch(setDataForDownloadExcelStart());

        return axios({
            method: 'get',
            responseType: 'arraybuffer',
            url: `/master-admin/platform-events-excel${sortBy ? `?sortBy=${sortBy}` : ''}${
                sortOrder ? `&sortOrder=${sortOrder}` : ''
            }${search ? (!sortBy ? `?search=${search}` : `&search=${search}`) : ''}`,
        })
            .then((response) => {
                const data = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
                });
                dispatch(setDataForDownloadExcelSuccess(data));
            })
            .catch((error) => {
                let errorMessage = "We couldn't set all events. Please try again.";
                dispatch(setDataForDownloadExcelFail(errorMessage));
            });
    };
};

const setDataForDownloadExcelStart = () => {
    return {
        type: actionTypes.SET_ADMIN_ALL_EVENTS_EXCEL_START,
    };
};
const setDataForDownloadExcelSuccess = (data) => {
    return {
        type: actionTypes.SET_ADMIN_ALL_EVENTS_EXCEL_SUCCESS,
        payload: data,
    };
};
const setDataForDownloadExcelFail = (errorMessage) => {
    return {
        type: actionTypes.SET_ADMIN_ALL_EVENTS_EXCEL_FAIL,
        payload: errorMessage,
    };
};

export const getEventsToday = () => {
    return (dispatch) => {
        dispatch(getEventsTodayStart());

        return axios({method: 'get', url: `/master-admin/platform-current-events`})
            .then((response) => {
                const data = response.data.events;
                dispatch(getEventsTodaySuccess(data));
            })
            .catch((error) => {
                let errorMessage = "We couldn't approve the organizer. Please try again.";
                dispatch(getEventsTodayFail(errorMessage));
            });
    };
};

const getEventsTodayStart = () => {
    return {
        type: actionTypes.GET_EVENTS_TODAY_START,
    };
};
const getEventsTodaySuccess = (data) => {
    return {
        type: actionTypes.GET_EVENTS_TODAY_SUCCESS,
        payload: data,
    };
};
const getEventsTodayFail = (errorMessage) => {
    return {
        type: actionTypes.GET_EVENTS_TODAY_FAIL,
        payload: errorMessage,
    };
};
